import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'privacy-policy-usa',
  templateUrl: './privacy-policy-usa.component.html',
  styleUrls: ['./privacy-policy-usa.component.scss'],
})
export class PrivacyPolicyUsa implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
